module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg width=\"1792\" height=\"1792\" viewBox=\"0 0 1792 1792\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1408 1088q0 26-19 45l-448 448q-19 19-45 19t-45-19l-448-448q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45zm0-384q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45 19-45l448-448q19-19 45-19t45 19l448 448q19 19 19 45z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./theroot/root-100-2019/src/img/sort.svg
// module id = 222
// module chunks = 0